import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f28090a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-col gap-3 text-left",
  "data-testid": "coverage-preview-summary"
}
const _hoisted_2 = { class: "flex flex-wrap gap-2" }
const _hoisted_3 = {
  class: "chip chip-open",
  "data-testid": "coverage-preview-count-open"
}
const _hoisted_4 = {
  class: "chip chip-doctor",
  "data-testid": "coverage-preview-count-doctor"
}
const _hoisted_5 = {
  class: "chip chip-unidentified",
  "data-testid": "coverage-preview-count-unidentified"
}
const _hoisted_6 = {
  key: 0,
  class: "chip chip-blocked",
  "data-testid": "coverage-preview-count-blocked"
}
const _hoisted_7 = {
  class: "chip-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-testid": "coverage-preview-blocked-icon"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = { class: "rounded-lg border border-solid border-lightGray30 bg-gray-50 px-3 py-2" }
const _hoisted_10 = {
  class: "text-sm font-bold text-textPrimary",
  "data-testid": "coverage-preview-title"
}
const _hoisted_11 = { class: "mt-1 flex flex-col gap-0.5 text-sm text-textPrimary" }
const _hoisted_12 = {
  key: 0,
  class: "guidance rounded-lg px-3 py-2 text-sm",
  "data-testid": "coverage-preview-antecipe-guidance"
}
const _hoisted_13 = { class: "flex items-center gap-1.5 font-bold" }
const _hoisted_14 = {
  class: "chip-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_15 = ["d"]
const _hoisted_16 = { class: "mt-1 flex list-decimal flex-col gap-0.5 pl-5" }

import { computed } from 'vue'
import { mdiLock } from '@mdi/js'
import { describeCoveragePlan } from '../modals/utils/coverageAllocation'
import type { CoveragePlan } from '../modals/utils/coverageAllocation'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoveragePreviewSummary',
  props: {
    plan: {},
    targetDoctorName: { default: null }
  },
  setup(__props: any) {

const props = __props;



const title = computed(() => {
  const n = props.plan.applicableRows.length
  if (n === 0) return 'Nenhum plantão será alterado'
  return `O que vai acontecer em ${n} ${n === 1 ? 'plantão' : 'plantões'}`
})
// Mesmos 3 passos do estado de bloqueio do M6-C (CoverageTransitionConfirmModal).
const ANTECIPE_GUIDANCE_STEPS = [
  'Confirme com o financeiro se o Antecipe foi de fato pago.',
  'Se o médico realizou o plantão, mantenha-o alocado.',
  'Se não realizou, trate o estorno antes de mudar a cobertura.'
]
const hasAntecipeBlock = computed(() =>
  props.plan.rows.some((row) => row.action === 'IGNORED' && row.blockedReason === 'ANTECIPE')
)
const lines = computed(() =>
  describeCoveragePlan(props.plan, { targetDoctorName: props.targetDoctorName })
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("Aberta "),
        _createElementVNode("b", null, _toDisplayString(_ctx.plan.counts.OPEN), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createTextVNode("Com médico "),
        _createElementVNode("b", null, _toDisplayString(_ctx.plan.counts.DOCTOR), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createTextVNode("Ocupado s/ ident. "),
        _createElementVNode("b", null, _toDisplayString(_ctx.plan.counts.UNIDENTIFIED), 1)
      ]),
      (_ctx.plan.counts.BLOCKED > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            (_openBlock(), _createElementBlock("svg", _hoisted_7, [
              _createElementVNode("path", { d: _unref(mdiLock) }, null, 8, _hoisted_8)
            ])),
            _createTextVNode("Bloqueado "),
            _createElementVNode("b", null, _toDisplayString(_ctx.plan.counts.BLOCKED), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("p", _hoisted_10, _toDisplayString(title.value), 1),
      _createElementVNode("ul", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lines.value, (line) => {
          return (_openBlock(), _createElementBlock("li", {
            key: line,
            "data-testid": "coverage-preview-line"
          }, _toDisplayString(line), 1))
        }), 128))
      ])
    ]),
    (hasAntecipeBlock.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, [
            (_openBlock(), _createElementBlock("svg", _hoisted_14, [
              _createElementVNode("path", { d: _unref(mdiLock) }, null, 8, _hoisted_15)
            ])),
            _createTextVNode(" O que fazer: ")
          ]),
          _createElementVNode("ol", _hoisted_16, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ANTECIPE_GUIDANCE_STEPS, (step) => {
              return _createElementVNode("li", { key: step }, _toDisplayString(step), 1)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})